"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c('div', {
    staticClass: "app-ircinput"
  }, [_c('div', {
    ref: "editor",
    staticClass: "app-ircinput-editor",
    attrs: {
      "placeholder": _vm.placeholder,
      "contenteditable": "true",
      "role": "textbox",
      "spellcheck": "true"
    },
    on: {
      "keypress": function ($event) {
        _vm.updateValueProps();
        _vm.$emit('keypress', $event);
      },
      "keydown": function ($event) {
        _vm.updateValueProps();
        _vm.$emit('keydown', $event);
      },
      "keyup": function ($event) {
        _vm.updateValueProps();
        _vm.$emit('keyup', $event);
      },
      "textInput": function ($event) {
        _vm.updateValueProps();
        _vm.onTextInput($event);
        _vm.$emit('textInput', $event);
      },
      "mouseup": function ($event) {
        return _vm.updateValueProps();
      },
      "click": function ($event) {
        return _vm.$emit('click', $event);
      },
      "paste": _vm.onPaste,
      "drop": _vm.onDrop,
      "focus": _vm.onFocus,
      "blur": _vm.onBlur
    }
  }), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.show_placeholder,
      expression: "show_placeholder"
    }],
    staticClass: "app-ircinput-placeholder",
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v(_vm._s(_vm.placeholder))])]);
};
var staticRenderFns = exports.staticRenderFns = [];